<template>
  <v-dialog :value="show" persistent max-width="440">
    <v-card>
      <v-card-title class="text-h6">
        <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
        Sessão alterada em outra aba
      </v-card-title>
      <v-card-text>
        O período letivo foi alterado em outra aba. Recarregue a página para continuar.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="reload">Recarregar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from '@/composables/useStore'

/**
 * Instituição, período e campus da sessão ficam no servidor, amarrados ao token —
 * que é o mesmo em todas as abas. Quando outra aba troca o período, esta passa a
 * receber dados do período novo, mas segue com o `acesso` antigo na memória
 * (ex.: atribuição gravada em 2026/2 com as datas de 2026/1).
 *
 * O evento `storage` só dispara nas OUTRAS abas, nunca na que escreveu.
 */
function sessionKey(acesso) {
  if (!acesso || !acesso.periodo) return null

  const campusIds = (acesso.campus || []).map(c => c.id).sort((a, b) => a - b)

  return [acesso.instituicao && acesso.instituicao.id, acesso.periodo.id, campusIds.join(',')].join('|')
}

export default {
  name: 'SessionChangedWatcher',
  setup() {
    const store = useStore()
    const show = ref(false)

    function onStorage(event) {
      // logout em outra aba remove a chave; o 401 já trata esse caso
      if (event.key !== 'acesso' || !event.newValue) return

      const current = sessionKey(store.state.auth.acesso)
      if (!current) return

      let next
      try {
        next = sessionKey(JSON.parse(event.newValue))
      } catch (e) {
        return
      }

      if (next && next !== current) {
        show.value = true
      }
    }

    function reload() {
      window.location.reload()
    }

    onMounted(() => window.addEventListener('storage', onStorage))
    onBeforeUnmount(() => window.removeEventListener('storage', onStorage))

    return { show, reload }
  },
}
</script>
